import { STAGE, fmtInt, ageTone } from "@/lib/format";
import { Trophy, X } from "@phosphor-icons/react";

export const TurnaroundLeaderboard = ({ leaderboard, activeBuyer, onSelectBuyer }) => {
  const data = (leaderboard || []).slice(0, 12);
  const maxAge = Math.max(1, ...data.map((d) => d.avg_age));

  return (
    <div className="col-span-12 border border-[#E3E7EC] bg-[#FFFFFF] p-5 lg:col-span-4">
      <div className="mb-4 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Trophy size={18} weight="duotone" className="text-amber-400" />
          <div>
            <h3 className="text-sm font-semibold text-[#0F172A]">Turnaround by Buyer</h3>
            <p className="pf-label mt-0.5">Avg days open · click to filter</p>
          </div>
        </div>
        {activeBuyer && (
          <button
            data-testid="leaderboard-clear-buyer"
            onClick={() => onSelectBuyer("")}
            className="flex items-center gap-1 rounded-sm border border-[#CAD1DB] bg-[#F1F3F6] px-2 py-1 text-[11px] text-[#64748B] hover:text-white"
          >
            <X size={12} weight="bold" /> clear
          </button>
        )}
      </div>
      <div className="flex flex-col" data-testid="turnaround-leaderboard">
        {data.map((d, i) => {
          const active = activeBuyer === d.buyer;
          return (
            <button
              key={d.buyer}
              data-testid={`leaderboard-row-${i}`}
              onClick={() => onSelectBuyer(active ? "" : d.buyer)}
              className={`group border-b border-[#E3E7EC]/60 py-2.5 text-left transition-colors last:border-0 ${
                active ? "bg-[#F0323E]/10" : "hover:bg-[#EDEFF3]"
              }`}
            >
              <div className="flex items-center justify-between gap-3 px-1">
                <div className="flex min-w-0 items-center gap-2">
                  <span className="w-5 shrink-0 font-mono text-xs text-[#9CA3AF]">{String(i + 1).padStart(2, "0")}</span>
                  <span className={`truncate text-sm ${active ? "font-semibold text-[#F0323E]" : "text-[#0F172A]"}`}>{d.buyer}</span>
                </div>
                <span className={`font-mono text-sm font-semibold ${ageTone(d.avg_age)}`}>{fmtInt(d.avg_age)}d</span>
              </div>
              <div className="ml-7 mt-1.5 flex items-center gap-3 px-1">
                <div className="h-1 flex-1 overflow-hidden rounded-full bg-[#F1F3F6]">
                  <div className="h-full rounded-full bg-[#F0323E]" style={{ width: `${(d.avg_age / maxAge) * 100}%` }} />
                </div>
                <div className="flex items-center gap-2">
                  {Object.keys(STAGE).map((k) =>
                    d[`${k}_count`] ? (
                      <span key={k} className="flex items-center gap-1 font-mono text-[10px] text-[#64748B]">
                        <span className="inline-block h-2 w-2" style={{ background: STAGE[k].color }} />
                        {fmtInt(d[`${k}_count`])}
                      </span>
                    ) : null
                  )}
                </div>
              </div>
            </button>
          );
        })}
        {data.length === 0 && <p className="py-6 text-center text-sm text-[#9CA3AF]">No data</p>}
      </div>
    </div>
  );
};
